/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { BaseError } from '../shared/errors/Errors';
import {
	ClientCommunity,
	ClientGeoArea,
	ClientGeoAreaExtended,
	ClientPersonOwn,
	ClientRoleInformation
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { noPermission, RoleManagementPermission } from '../shared/services/Role.service';

export interface GeoAreaData {
	geoArea: ClientGeoArea | null;
	loading: boolean;
	error: BaseError | null;
}

export interface GeoAreasData {
	geoAreas: ClientGeoAreaExtended[];
	loading: boolean;
	error: BaseError | null;
}

export interface GlobalState {
	error: BaseError | null;
	loading: boolean;
	tenants: ClientCommunity[];
	allAvailableRoles: ClientRoleInformation[];
	assignableRoles: ClientRoleInformation[];
	roleManagementPermission: RoleManagementPermission;
	person: ClientPersonOwn | null;
	geoAreaData: GeoAreaData;
	geoAreasData: GeoAreasData;
}

export const initialGlobalState: GlobalState = {
	error: null,
	loading: true,
	tenants: [],
	allAvailableRoles: [],
	assignableRoles: [],
	roleManagementPermission: noPermission,
	person: null,
	geoAreaData: { geoArea: null, loading: false, error: null },
	geoAreasData: { geoAreas: [], loading: false, error: null }
};
